import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicField, FieldVariant, FileFieldProps } from '@/components/form-builder/form-builder.types';
import { PaaRepository } from '@/store/paa-state/paa-state.repository';
import { FileRemoveEvent, FileSelectEvent } from 'primeng/fileupload';

interface getPAAUploadDialogProps {
  store: PaaRepository;
  validate: () => void;
}

export const getPAAUploadDialog = ({ store, validate }: getPAAUploadDialogProps): DialogObject => {
  const fileField: DynamicField<FileFieldProps> = {
    label: 'Modèle PAA',
    variant: FieldVariant.FILE,
    isRequired: true,
    props: {
      mode: 'basic',
      accept: 'application/pdf',
      multiple: false,
      value: store.getNestedObservable<File[]>('upload', 'modelPaaFile'),
      onFileSelect: (event: FileSelectEvent) => {
        store.setNested('upload', 'modelPaaFile', event.currentFiles);
      },
      onFileRemoved: (event: FileRemoveEvent) => {
        store.setNested(
          'upload',
          'modelPaaFile',
          store.getNested<File[]>('upload', 'modelPaaFile').filter(file => file.name !== event.file.name)
        );
      },
      message: 'common.files.warn',
    },
  };

  return {
    title: 'Téléversement',
    actions: [
      {
        label: 'paa.actions.validate',
        variant: 'success',
        onClick: () => validate(),
      },
    ],
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: {
          title: '',
          description: '',
          isHeaderHidden: true,
          class: '',
          grids: [
            {
              title: '',
              isHeaderHidden: true,
              gridItems: [
                {
                  fields: [fileField],
                },
              ],
            },
          ],
        },
      },
    },
  };
};
